import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";

export const SearchResultCard = styled(Card)(({ theme }) => ({
  zIndex: 99,
  top: "100%",
  width: "100%",
  position: "absolute",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  marginTop: theme.spacing(0.5),
  maxHeight: `min(50vh, ${theme.spacing(45)})`,
  overflowX: "hidden",
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
}));

export default SearchResultCard;
